import { c } from '../../utils/tailwind-merge';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '../Tooltip/TooltipRadix';
import type { BadgeProps, BadgePropsContent } from './types';

const BadgeContent = ({ text }: BadgePropsContent) => (
  <div className="flex" aria-label={text}>
    {text}
  </div>
);

export const Badge = ({ text, tooltip, className = '' }: BadgeProps) => {
  return (
    <div
      className={c(
        'rounded-sm bg-grey-100 px-1.5 py-0.5 text-xs font-normal tracking-tighter text-grey-700',
        className
      )}
    >
      {!tooltip ? (
        <BadgeContent text={text} />
      ) : (
        <Tooltip>
          <TooltipTrigger aria-label={text}>
            <BadgeContent text={text} />
          </TooltipTrigger>
          <TooltipContent className="text-sm text-grey-700">
            {tooltip}
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
};
